import { IBasicInfoSectionContent } from "../BasicInfoSection";
import { ISkillsSectionContent } from "../SkillsSection";

export interface IPaperCVContent {
  noteLabel: string;
  webSiteLabel: string;
  creditsLabel: string;
  furtherCredits: string;
  prodAndRoleNameLabel: string;
  directorLabel: string;
  dateLabel: string;
  prodTypeLabel: string;
  companyLabel: string;
  venueLabel: string;
  contactsSectionLabel: string;
  gallerySectionLabel: string;
  profileSectionLabel: string;
  aboutMeLabel: string;
  trainingLabel: string;
  footer: string;
  basicInfoSection: IBasicInfoSectionContent;
  skillsSection: ISkillsSectionContent;
  agencyDetailsTelephone: string;
  agencyDetailsMobilePhone: string;
}
export const IPaperCVContentKeys = [
  "noteLabel",
  "webSiteLabel",
  "creditsLabel",
  "furtherCredits",
  "prodAndRoleNameLabel",
  "directorLabel",
  "dateLabel",
  "prodTypeLabel",
  "companyLabel",
  "venueLabel",
  "contactsSectionLabel",
  "gallerySectionLabel",
  "profileSectionLabel",
  "aboutMeLabel",
  "trainingLabel",
  "footer",
  "basicInfoSection",
  "skillsSection",
  "agencyDetailsTelephone",
  "agencyDetailsMobilePhone",
];
